import { render, staticRenderFns } from "./document-details-lender-features.vue?vue&type=template&id=a559d488&"
import script from "./document-details-lender-features.vue?vue&type=script&lang=ts&"
export * from "./document-details-lender-features.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports